document.addEventListener('DOMContentLoaded', () => {
  const mobileBreakpoint = 1024;
  const menuItems = document.querySelectorAll('.custom-footer__menu');

  function closeAllMenus(except = null) {
    menuItems.forEach((item) => {
      if (item !== except) {
        item.classList.remove('active');

        const button = item.querySelector('.custom-footer__heading');
        const content = item.querySelector('.custom-footer__links');

        button?.setAttribute('aria-expanded', 'false');

        if (content) {
          content.style.maxHeight = null;
        }
      }
    });
  }

  menuItems.forEach((item) => {
    const button = item.querySelector('.custom-footer__heading');
    const content = item.querySelector('.custom-footer__links');

    if (!button || !content) return;

    button.setAttribute('aria-expanded', 'false');

    button.addEventListener('click', () => {
      if (window.innerWidth >= mobileBreakpoint) return;

      const isOpen = item.classList.contains('active');

      closeAllMenus(item);

      if (isOpen) {
        item.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
      } else {
        item.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    });
  });

  // Open first menu by default on mobile
  function openFirstMenu() {
    if (window.innerWidth >= mobileBreakpoint || !menuItems.length) return;

    closeAllMenus();

    const firstItem = menuItems[0];
    const firstButton = firstItem.querySelector('.custom-footer__heading');
    const firstContent = firstItem.querySelector('.custom-footer__links');

    firstItem.classList.add('active');
    firstButton?.setAttribute('aria-expanded', 'true');

    if (firstContent) {
      firstContent.style.maxHeight = `${firstContent.scrollHeight}px`;
    }
  }

  // Open first menu on page load
  openFirstMenu();

  window.addEventListener('resize', () => {
    if (window.innerWidth >= mobileBreakpoint) {
      menuItems.forEach((item) => {
        item.classList.remove('active');

        const button = item.querySelector('.custom-footer__heading');
        const content = item.querySelector('.custom-footer__links');

        button?.setAttribute('aria-expanded', 'false');

        if (content) {
          content.style.maxHeight = null;
        }
      });
    } else {
      // Reopen first menu if none are open
      if (![...menuItems].some((item) => item.classList.contains('active'))) {
        openFirstMenu();
      }
    }
  });
});